module.exports = __webpack_public_path__ + "img/mv--avatar2.c9eab2d3.png";